/**
 * SkuImageDialog.jsx — extracted from Inventory.jsx (iter-121 refactor).
 * Lightweight wrapper around the existing SkuImageUploader so the page
 * doesn't carry the Dialog/Header boilerplate.
 *
 * Props:
 *  - sku         the SKU object whose image we're editing (or null/closed)
 *  - onClose     () => void
 *  - onUploaded  (image_base64) => void — parent updates its local list
 */
import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from './ui/dialog';
import SkuImageUploader from './SkuImageUploader';

export default function SkuImageDialog({ sku, onClose, onUploaded }) {
  return (
    <Dialog open={!!sku} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="border border-border rounded-none">
        <DialogHeader>
          <DialogTitle>Image · {sku?.sku_code}</DialogTitle>
        </DialogHeader>
        {sku && (
          <SkuImageUploader
            skuId={sku.id}
            currentImage={sku.image_base64 || null}
            onUploaded={onUploaded}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
